<template>
  <div>
    <div class="btn-group d-none d-md-block" role="group">
      <button type="button" class="btn btn-lg" :class="{ 'btn-secondary': selected, 'btn-success': !selected }"
              @click="onOperationTypeChanged(null)">
        Näytä kaikki
      </button><button v-for="type in operationTypes" :key="type.value" type="button"
              class="btn btn-lg" :class="{ 'btn-secondary': type != selected, 'btn-success': type == selected }"
              @click="onOperationTypeChanged(type)">
        {{ type.label }}
      </button>
    </div>

    <select class="form-control d-md-none" v-model="selected" @change="emitChange()">
      <option :value="null">Näytä kaikki</option>
      <option v-for="type in operationTypes" :key="'mobile-' + type.value" :value="type">
        {{ type.label }}
      </option>
    </select>
  </div>
</template>

<script>
  export default {
    props: {
      operationTypes: null
    },

    data() {
      return {
        selected: null
      }
    },

    methods: {
      onOperationTypeChanged(operationType) {
        this.selected = operationType
        this.emitChange()
      },

      emitChange() {
        this.$emit('operationTypeChanged', this.selected)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OperationListFilter.vue